module.exports = __webpack_public_path__ + "static/img/esim1 (2).ce3757c7.jpg";